export default function() {
  return new Promise(resolve => {
    if (process.client) {
      requestAnimationFrame(() => {
        const elements = document.querySelectorAll('main')
        if (elements.length >= 2) {
          elements[1].scrollTop = 0
        }
        resolve()
      })
    } else {
      resolve()
    }
  })
}
